export default __webpack_public_path__ + "static/media/explore_new_skills.72e0b652.jpg";